import { render } from "./BuildingFloors.vue?vue&type=template&id=ef069e18&scoped=true"
import script from "./BuildingFloors.vue?vue&type=script&lang=js"
export * from "./BuildingFloors.vue?vue&type=script&lang=js"

import "./BuildingFloors.vue?vue&type=style&index=0&id=ef069e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef069e18"]])

export default __exports__